var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "add-item-form",
    _vm._b(
      { on: { created: _vm.onCreated } },
      "add-item-form",
      _vm.formData,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }